// Analytics utility functions for Matomo tracking

// Core tracking functions
export const trackEvent = (category: string, action: string, name?: string, value?: number) => {
  if (window._paq) {
    window._paq.push(['trackEvent', category, action, name, value])
  }
}

export const trackGoal = (goalId: number, customRevenue?: number) => {
  if (window._paq) {
    window._paq.push(['trackGoal', goalId, customRevenue])
  }
}

// Specific tracking functions for Demirix events
export const trackConsultationClick = () => {
  trackEvent('Lead Generation', 'Consultation Button Click', 'Schedule Free Consultation')
}

export const trackContactFormSubmit = () => {
  trackEvent('Lead Generation', 'Contact Form Submit', 'Contact Form')
}

export const trackServiceClick = (serviceName: string) => {
  trackEvent('Service Interest', 'Service Click', serviceName)
}

export const trackEmailSignup = () => {
  trackEvent('Lead Generation', 'Email Signup', 'Newsletter Subscription')
}

export const trackThemeToggle = (theme: string) => {
  trackEvent('User Experience', 'Theme Toggle', theme)
}

export const trackCalendlyOpen = () => {
  trackEvent('Lead Generation', 'Calendly Open', 'Consultation Booking')
}